import React, { Component } from "react";
import { connect } from "react-redux";
import CustomBoardGiro from "../../../components/CustomBoardGiro";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../components/CustomText";
import Color from "../../../../utils/Color";
import Grid from "@material-ui/core/Grid";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomButton from "../../../components/CustomButton";
import * as selector from "../../../../common/selectors";
import * as onlineRenewalSelector from "../../../../common/selectors/onlineRenewal";
import * as onlineRenewalAction from "../../../../common/actions/onlineRenewal";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LoadingOverlay from "../../../components/LoadingOverlay";
import CustomPaper from "../../../components/CustomPaper";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Image from "../../../../assets";
import CustomBoardSelectEnrolment from "../../../components/CustomBoardSelectEnrolment";
import _ from "lodash";
import CustomEnrolGiroNowV2 from "../../../components/CustomEnrolGiroNowV2";

const policyInfo = {
  policyNo: "M0001033",
  productName: "Commercial Motor",
  startDate: "31/08/2020",
  endDate: "30/09/2020",
  renewalPremium: "1,343.15",
};

const screenW = window.screen.width + "px";
const screenH = "450" + "px";

class DDAMissMatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      localPolicyNo: "",
      localStatus: "",
      localNric: "",
      localPremium: "",
      localIsRecurring: false,
      localProduct: "",
      localCoveragePeriod: "",
      localStatusLabel: "",
      localMsg: "",
      checkedA: false,
      localShowRecurringCheckBox: false,
      loadingToReddot: false,
      localErrorCode: "",
      localErrorMsg: "",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    var status = this.getUrlVars()["status"];
    var policy = this.getUrlVars()["Policy"];
    this.setState({
      localStatus: status === "success" ? true : false,
      localPolicyNo: policy,
    });
    var errorCode = this.getUrlVars()["ErrorCode"];
    var errorMsg = this.getUrlVars()["ErrorMessage"];
    //console.log("typeof", errorCode.length);
    this.setState({ localErrorCode: errorCode, localErrorMsg: errorMsg });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidUpdate = () => {};

  getUrlVars() {
    var url = window.location.href,
      vars = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      key = decodeURIComponent(key);
      value = decodeURIComponent(value);
      vars[key] = value;
    });
    return vars;
  }

  onClickLetGo = () => {
    //this.onClickPayRenewal();
    this.props.history.push("/EnrolGiro");
  };

  onClickEnrolNow = () => {
    this.props.history.push("/EnrolmentStatus");
  };

  onClickHere = () => {};

  handleChangeCheckedA = (event) => {
    this.setState({ checkedA: event.target.checked });
  };

  retryEnrol = () => {
    this.props.history.push("/EnrolGiro");
  };

  renderChildren = () => {
    const { classes } = this.props;
    const {
      policyNo,
      productName,
      startDate,
      endDate,
      renewalPremium,
    } = policyInfo;
    const {
      localPolicyNo,
      localOrderNo,
      localNric,
      localPremium,
      localIsRecurring,
      localCoveragePeriod,
      localProduct,
      localStatusLabel,
      localMsg,
      loadingToReddot,
      isSwitchFundSuccess = true,

      localErrorCode,
      localErrorMsg,
    } = this.state;
    return (
      <Grid
        container
        direction={"row"}
        justify={"center"}
        alignItems={"center"}
        style={{ marginTop: window.innerWidth < 600 ? "-5em" : false }}
      >
        <Grid item xs={12} md={12}>
          <CustomPaper design={classes.submitPaper}>
            <Grid
              container
              direction={"column"}
              justify={"center"}
              alignItems={"center"}
              spacing={2}
              style={{
                paddingLeft: window.innerWidth < 600 ? false : "5em",
                paddingRight: window.innerWidth < 600 ? false : "5em",
                // minWidth:500,
                //width:1020
              }}
            >
              <div className={classes.containerStyle}>
                <CustomText design={classes.titleTextStyle}>
                  There is a mismatch between the name in this Application Form
                  and Bank Account holder name. Please kindly confirm if this is
                  your bank account?
                </CustomText>
              </div>
            </Grid>
          </CustomPaper>

          <Grid
            item
            style={{
              //paddingLeft: 150,
              //paddingRight: 150,
              justifyContent: "center",
              alignItems: "center",
              display: "flex-start",

              marginTop: 15,
            }}
          >
            <CustomButton
              onClick={this.retryEnrol}
              style={{ textTransform: "none" }}
            >
              Yes
            </CustomButton>
          </Grid>
          <Grid
            item
            style={{
              //paddingLeft: 150,
              //paddingRight: 150,
              justifyContent: "center",
              alignItems: "center",
              display: "flex-start",

              marginTop: 15,
            }}
          >
            <CustomButton
              onClick={this.retryEnrol}
              style={{ textTransform: "none" }}
            >
              No
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  renderChildrenV2 = () => {
    const { classes } = this.props;
    const { policyNo, isOnClickNext, errorMsg, error } = this.state;
    return (
      <CustomPaper
        container
        direction={"column"}
        spacing={2}
        design={classes.paper}
      >
        <Grid
          item
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: "5%",
            paddingRight: "5%",
            marginBottom: "3%",
          }}
        >
          {" "}
          <div className={classes.containerStyle}>
            <CustomText design={classes.titleTextStyle}>
              Please confirm this is your bank account.
            </CustomText>
          </div>
        </Grid>

        <Grid container style={{ paddingLeft: "5%", paddingRight: "5%" }}>
          <Grid item xs={5}>
            <CustomButton
              onClick={this.retryEnrol}
              style={{ textTransform: "none" }}
            >
              Yes
            </CustomButton>
          </Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={5}>
            <CustomButton
              onClick={this.retryEnrol}
              style={{ textTransform: "none" }}
              design={classes.cancelButtonTextStyle}
            >
              No
            </CustomButton>
          </Grid>
        </Grid>
      </CustomPaper>
    );
  };

  render() {
    const { classes } = this.props;
    const { height, width } = this.state;
    return (
      <div className={classes.root}>
        {/* <CustomEnrolGiroNowV2
            children={this.renderChildren()}
            height={window.innerWidth < 600 ? height + 200 : height}
            width={width}
          /> */}
        {window.innerWidth > 600 ? (
          <AppBar
            position="sticky"
            className={classes.appBar}
            style={{ background: "#333333" }}
          >
            <Toolbar
              className={classes.toolbarStyle}
              style={{
                justifyContent: "space-between",
                //alignItems: "center",
                display: "flex-start",
                flexDirection: "row",
                marginLeft: "5em",
              }}
            >
              <img
                src={Image.nonDirectClientEtiqaLogo}
                style={{ width: 112, height: 60 }}
              />
            </Toolbar>
          </AppBar>
        ) : (
          false
        )}
        {window.innerWidth > 600 ? this.renderChildrenV2() : false}
        {window.innerWidth < 601 ? (
          <CustomEnrolGiroNowV2
            children={this.renderChildrenV2()}
            height={height}
            width={width}
          />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f4f4f4",
    maxHeight: "100vh",
    minHeight: "100vh",
    backgroundImage:
      window.innerWidth < 601 ? false : `url(${Image.enrolGiroBg})`,
    backgroundSize: window.innerWidth < 601 ? false : `${screenW} ${screenH}`,
    backgroundPosition: window.innerWidth < 601 ? false : "bottom center",
    backgroundRepeat: window.innerWidth < 601 ? false : "no-repeat",
  },
  imageStyle: {
    width: 57,
    height: 57,
    alignItems: "center",
  },
  bottomImageStyle: {
    width: 20,
    height: 20,
    marginRight: 10,
    color: Color.primaryTextColor,
  },
  labelTextInputTextStyle: {
    ...getFontWeight("300"),
    ...getFontSize("small"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
    marginTop: 10,
  },
  letGoButtonStyle: {
    //width: 120,
    marginTop: 20,
    //marginBottom:"1em"
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  bottomTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    fontFamily: "Muli",
  },
  highLightedTextStyle: {
    color: "#1858b9",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  // renewNowTextStyle: {
  //   ...getFontWeight("800"),
  //   fontSize: 28,
  //   textAlign: "center",
  //   color: "#2c3034",
  //   marginBottom: 10,
  // },
  errorTextStyle: {
    color: "red",
  },

  checked: {},
  optTextStyle: {
    fontSize: 13,
    opacity: 0.7,
  },
  submitPaper: {
    //margin: 20,
    border: "1px solid #C5C5C5",
    borderRadius: " 0",
    //minWidth:500
  },
  failurePaymentPaper: {
    margin: 20,
    [theme.breakpoints.between("sm", "md")]: {
      width: 600,
    },
    [theme.breakpoints.up("lg")]: {
      width: 800,
    },
  },
  appBar: {
    background:
      "transparent linear-gradient(143deg, #004880 0%, #0066A7 31%,#007F9C 59%,#008992 80%,#00FFAF 100%) 0% 0% no-repeat padding-box",
  },
  titleStyle: {
    fontSize: "22px",
    ...getFontWeight("800"),
    marginBottom: 20,
  },
  backButton: {
    //width: 120,
    marginTop: 20,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  paper: {
    // overflow: "auto",
    //backgroundColor: "#f4f4f4",
    //width:"828px",
    marginTop: window.innerWidth < 601 ? false : "6%",
    marginLeft: window.innerWidth < 601 ? false : "25%",
    marginRight: window.innerWidth < 601 ? false : "25%",
  },
  renewNowTextStyle: {
    fontWeight: "bold",
    fontFamily:"Muli",
    fontSize: 22,
    textAlign: "center",
    marginBottom: 10,
    marginTop: 10,
  },
  noteTextStyle: {
    fontFamily:"Muli",
    fontSize: "16px",
    fontWeight: "400",
    color: "#424143",
  },
  cancelButtonTextStyle: {
    backgroundColor: "#fff",
    color: "#424143",
    borderRadius: 8,
    "&:focus": {
      color: "white",
      //backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
    "&:hover": {
      color: "white",
      // backgroundColor: Color.blackButtonColor
    },
  },
});

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(DDAMissMatch)));
